import React from "react";
import { createRoot } from "reactdom";
import VideoPlayer from "../components/VideoPlayer";

// function called on frontend.js to render the video player

const renderVideoPlayer = () => {
	const videoPlayerElements =
		document.getElementsByClassName("js-video-player");

	if (videoPlayerElements) {
		Array.from(videoPlayerElements).forEach(function (video) {
			const root = createRoot(video);
			root.render(<VideoPlayer {...video.dataset} />);
		});
	}
};

export default renderVideoPlayer;
